export interface FirestoreTimestamp {
    seconds: number;
    nanoseconds: number;
  }

// Use this to convert FirestoreTimestamp to a string 
// FirestoreTimeStamp Example {seconds: 1630000000, nanoseconds: 0}
export const FirestoreTimestampToDate = (timestamp?: FirestoreTimestamp): string => {
    if (
      !timestamp ||
      typeof timestamp.seconds !== "number" ||
      typeof timestamp.nanoseconds !== "number"
    ) {
      return "Invalid date"; // or handle the error as needed
    }

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);
    const formattedDate = date.toLocaleDateString();
    return formattedDate;
  };
